import { useMemo } from "react";
import { useRetriesForJob } from "~/components/build/Show/lib/BuildContext";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";
import { CommandJob } from "~/components/build/Show/lib/types";
import { Step } from "~/lib/pipeline";

const RetryLabel = ({ retryCount }: { retryCount: number }) => {
  if (retryCount === 0) {
    return null;
  }

  return (
    <span className="text-charcoal-500 text-xs font-medium underline decoration-gray-600 decoration-dashed underline-offset-2">
      {retryCount > 1 ? `${retryCount} retries` : `${retryCount} retry`}
    </span>
  );
};

/** @deprecated Use `~/components/build/Show/pages/steps/list/components/TreeNode/JobRetries` instead. */
export function StepRetries({ step }: { step: Step }) {
  const stepJobs = useBuildStore((state) => state.stepJobs);

  const retryCount = useMemo(() => {
    if (Features.ProgressiveBuildShow) {
      return step.statistics?.retriesCount || 0;
    }
    return (stepJobs.get(step.uuid) || []).length - 1;
  }, [step, stepJobs]);

  if (retryCount === 0) {
    return null;
  }

  return <RetryLabel retryCount={retryCount} />;
}

/** @deprecated Use `~/components/build/Show/pages/steps/list/components/TreeNode/JobRetries` instead. */
export function JobRetries({ job }: { job: CommandJob }) {
  const jobs = useRetriesForJob(job);
  const retryCount = jobs.length - 1;

  if (!jobs.length) {
    return null;
  }

  return <RetryLabel retryCount={retryCount} />;
}
